<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg4 pr-6 pl-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuStart"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedStartDateFormatted"
                    label="Từ ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.startDate" no-title @input="menuStart = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg4 pr-6>
          <v-layout row wrap justify-end>
            <v-menu
                v-model="menuEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="computedEndDateFormatted"
                    label="Đến ngày"
                    hint="DD-MM-YYYY"
                    persistent-hint
                    prepend-icon="fa-calendar-alt"
                    readonly
                    v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker v-model="dateRange.endDate" no-title @input="menuEnd = false"></v-date-picker>
            </v-menu>
          </v-layout>
        </v-flex>
        <v-flex lg4 pr-6>
            <v-btn @click="filter_data" color="#a77800" outlined>Xem</v-btn>
        </v-flex>
        <v-flex lg12>
            <v-card class="mb-8">
                <v-data-table hide-default-footer :headers="headers" :items="items" :server-items-length="items ? items.length : 0" :options.sync="pagination" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.BuyDate.toString().replace(/(\d{4})(\d{2})(\d{2})/, "$3-$2-$1") }}</td>
                            <td class="text-end">{{ item.TotalAmount | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.TotalRealAmount | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.TotalDiff | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.TotalCompletedAmount | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.TotalCompletedRealAmount | currency('¥', 2)}}</td>
                            <td class="text-end">{{ item.TotalCompletedDiff | currency('¥', 2)}}</td>
                            <!-- <td class="text-end">{{ item.Reward | currency('¥', 2)}}</td> -->
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr>
                            <td class="font-weight-bold">TỔNG</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalAmount | currency('¥', 2)}}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalRealAmount | currency('¥', 2)}}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalDiff | currency('¥', 2)}}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalCompletedAmount | currency('¥', 2)}}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalCompletedRealAmount | currency('¥', 2)}}</td>
                            <td class="text-end font-weight-bold">{{dic_summary.TotalCompletedDiff | currency('¥', 2)}}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "../../configs";
import { request_list } from '@/commons/hpod';
import Vue from 'vue';
import _ from "lodash";
import moment from "moment"
export default {
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            headers: [
                {
                    text: "Ngày mua hàng",
                    value: "BuyDate",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền đơn hàng",
                    value: "TotalAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền mua thật",
                    value: "TotalRealAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng chênh lệch",
                    value: "TotalDiff",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền đơn HT",
                    value: "TotalCompletedAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng tiền mua thật HT",
                    value: "TotalCompletedRealAmount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Tổng chênh lệch HT",
                    value: "TotalCompletedDiff",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                // {
                //     text: "Thưởng",
                //     value: "Reward",
                //     align: "end",
                //     filterable: true,
                //     dataType: dataType["Number"]
                // }
            ],
            viewName: "thong-ke-loi-nhuan-dat-hang",
            dateRange: {
                startDate: moment.utc(Date.now()).startOf('month').toISOString().substr(0, 10),
                endDate: moment.utc(Date.now()).endOf('month').toISOString().substr(0, 10),
            },
            menuStart: false,
            menuEnd: false,
            pagination: { ...configs.PAGINATION, itemsPerPage: 1000, sortBy: ["BuyDate"]},
        };
    },
    computed: {
        ...mapState({
            items: state => state.report.orderRevenue.data,
            loading: state => state.report.loading,
            staffs: state =>
                _.filter(state.commons.all_users, function(o) {
                return ((o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase) || ((o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService);
            }),
        }),
        computedStartDateFormatted () {
            return moment(this.dateRange.startDate).format(configs.SHORT_DATE_FORMAT);
        },
        computedEndDateFormatted () {
            return moment(this.dateRange.endDate).format(configs.SHORT_DATE_FORMAT);
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        dic_summary() {
            let dic = {
                'NumberOfOrder': _.sumBy(this.items, 'NumberOfOrder'),
                'NumberOfLink': _.sumBy(this.items, 'NumberOfLink'),
                'TotalAmount': _.sumBy(this.items, 'TotalAmount'),
                'TotalRealAmount': _.sumBy(this.items, 'TotalRealAmount'),
                'TotalDiff': _.sumBy(this.items, 'TotalDiff'),
                'TotalCompletedAmount': _.sumBy(this.items, 'TotalCompletedAmount'),
                'TotalCompletedRealAmount': _.sumBy(this.items, 'TotalCompletedRealAmount'),
                'TotalCompletedDiff': _.sumBy(this.items, 'TotalCompletedDiff'),
                'Reward': _.sumBy(this.items, 'Reward'),
                'KPI': 0
            }
            dic.KPI = dic.TotalDiff/dic.TotalAmount*100;
            return dic;
        }
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                this.filter_data();
            },
            deep: true
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                startTime: moment(this.dateRange.startDate).format(configs.SQL_DATE_FORMAT),
                endTime: moment(this.dateRange.endDate).format(configs.SQL_DATE_FORMAT),
            };
            this.$store.dispatch("report/getOrderRevenue", param);
        },
        getStaffName(staffId) {
            const staff = _.find(this.staffs, {
                ID: staffId
            });
            return staff ? staff.FullName : "";
        },
    },
    mounted() {
        this.$store.dispatch("commons/getAllUsers");
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>